import { useMutation } from '@tanstack/react-query'
import { LakehouseSyncScheduleEnum } from '@vendia/management-api-types'

import { useNodeApi } from '../api-provider'

export const useAddTableTaskTriggerConfig = () => {
  const nodeApi = useNodeApi()
  const { urqlClient } = nodeApi

  return useMutation({
    mutationFn: async ({
      tableId,
      chainConfig,
      schedule,
    }: {
      tableId: string
      chainConfig: { taskId: string; sourceChainMode: string }[]
      schedule: {
        cron: LakehouseSyncScheduleEnum
        taskId: string
      }[]
    }) => {
      if (!urqlClient) {
        throw new Error('Node API client is not available')
      }
      const result = await urqlClient
        .mutation(
          /* GraphQL */ `
            mutation AddTableTaskTriggerConfig(
              $chainConfig: [Vendia__definitions_Vendia_ChainConfig_Input_]!
              $schedule: [Vendia__definitions_Vendia_ScheduleConfig_Input_]!
              $tableId: String!
            ) {
              addVendia_TableTaskTriggerConfig(
                input: { chainConfig: $chainConfig, schedule: $schedule, tableId: $tableId }
                syncMode: NODE_LEDGERED
              ) {
                result {
                  _id
                }
              }
            }
          `,
          { tableId, chainConfig, schedule },
        )
        .toPromise()

      if (result.error) {
        throw new Error(result.error.message)
      }

      return result.data?.addVendia_TableTaskTriggerConfig.result
    },
    onError: (error) => {
      console.error('Error adding table task trigger config:', error)
    },
  })
}
